<template>
  <VDropdown v-if="Object.keys(messages).length > 1" placement="bottom" :distance="6">
    <button class="dropbtn">{{ selectedLanguage }}</button>

    <template #popper="{ hide }">
      <div class="dropdown-content">
        <a
          href="#"
          v-for="language in Object.keys(messages)"
          :key="language"
          @click.prevent="selectLanguage(language, $event), hide()"
        >
          {{ language }}
        </a>
      </div>
    </template>
  </VDropdown>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import VDropdown from '@/components/VDropdown.vue'

export default defineComponent({
  name: 'VLanguageDropdown',
  components: {
    VDropdown
  },

  setup() {
    const { t, locale, messages } = useI18n()
    const route = useRoute()
    const router = useRouter()

    const selectedLanguage = ref(locale.value)

    document.title = t('head_title')
    document.documentElement.lang = locale.value

    const selectLanguage = (language, e) => {
      selectedLanguage.value = language
      locale.value = language

      document.documentElement.lang = locale.value
      document.title = t('head_title')
      router.push({ query: { ...route.query, lang: locale.value } })

      e.stopPropagation()
    }

    return {
      locale,
      selectedLanguage,
      messages,
      selectLanguage
    }
  }
})
</script>

<style lang="scss" scoped>
.dropbtn {
  color: var(--font_second);
  text-decoration: underline;
  font-size: 18px;
  border: none;
  cursor: pointer;
  background: none;

  &:hover {
    color: var(--font_main);
  }
}

.dropdown-content {
  background-color: var(--btn);
  border-radius: 16px;
}

.dropdown-content a {
  color: var(--font_main);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-size: 18px;

  &:hover {
    text-decoration: underline;
  }
}
</style>
